import { render, staticRenderFns } from "./IntegrationView.vue?vue&type=template&id=bab15322"
import script from "./IntegrationView.vue?vue&type=script&lang=js"
export * from "./IntegrationView.vue?vue&type=script&lang=js"
import style0 from "./IntegrationView.vue?vue&type=style&index=0&id=bab15322&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports